import { LabelChip, Stack } from '@cast/design-system';

import { CatalogueLabel } from '../constants';

const MAX_VISIBLE_LABELS = 3;

type Props = {
  labels: CatalogueLabel[];
};

export const LabelChips = ({ labels }: Props) => {
  const visibleLabels = labels.slice(0, MAX_VISIBLE_LABELS);
  const hiddenCount = labels.length - visibleLabels.length;

  return (
    <Stack direction="row" gap={4} flexWrap="wrap" sx={{ minWidth: 0 }}>
      {visibleLabels.map((label) => (
        <LabelChip key={label.id} size="sm">
          {label.displayName}
        </LabelChip>
      ))}
      {hiddenCount > 0 && <LabelChip size="sm">+{hiddenCount}</LabelChip>}
    </Stack>
  );
};
